import PropTypes from 'prop-types';
import { useState } from 'react';
import moment from 'moment';
// @mui
import { Dialog, DialogTitle, TextField, DialogActions, Button, Stack, Typography, styled } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Iconify from '../../components/Iconify';
import useLocales from '../../hooks/useLocales';
import CustomModal from '../../components/CustomModal';
import MyDialog from '../../components/dialog-component/my-dialog';

// const ContentStyle = styled(Stack)(({ theme }) => ({
//   alignItems: 'left',
//   flexDirection: 'column',
//   backgroundColor: '#2a2a2a',
//   // border: '2px solid #1CBC40',
//   borderRadius: '16px',
// }));

const ApplyButton = styled(LoadingButton)(({ theme }) => ({
  width: '100%',
  marginBottom: 8,
  background: 'linear-gradient(to top, #FFD700, #B8860B)',
  color: '#fff',
  fontWeight: 500,
  fontSize: '17px',
}));

// ----------------------------------------------------------------------

TxnDateRangePicker.propTypes = {
  open: PropTypes.bool,
  filters: PropTypes.object,
  onFilterChange: PropTypes.func,
  close: PropTypes.func,
};

export default function TxnDateRangePicker({ open, filters, onFilterChange, close }) {
  const { translate } = useLocales();

  const [dateFrom, setDateFrom] = useState(filters?.dateFrom || null);

  const [dateTo, setDateTo] = useState(filters?.dateTo || null);

  const [error, setError] = useState('');

  const onApplyDate = () => {
    if (dateFrom && dateTo) {
      setError('');
      onFilterChange((prevState) => ({ ...prevState, dateFrom, dateTo }));
      close();
    } else {
      setError(translate('select_both_date'));
    }
  };

  return (
    <MyDialog open={open} close={close} maxWidth="xs" fullWidth>
      {/* <ContentStyle spacing={2} p={2}> */}
      <Typography color={'#d4af37'} fontSize="20px" fontWeight={800}>
        {translate('choose_date')}
      </Typography>
      <Stack spacing={2} mb={2}>
        <DatePicker
          label={translate('from')}
          value={dateFrom}
          onChange={(v) => setDateFrom(moment(v).format('YYYY-MM-DD'))}
          renderInput={(params) => (
            <TextField
              {...params}
              sx={{
                '& input': {
                  color: '#fff',
                  '&::placeholder': {
                    color: 'rgba(255, 255, 255) !important',
                    padding: 0,
                  },
                },
              }}
            />
          )}
        />

        <DatePicker
          label={translate('to')}
          value={dateTo}
          onChange={(v) => setDateTo(moment(v).format('YYYY-MM-DD'))}
          renderInput={(params) => (
            <TextField
              {...params}
              sx={{
                '& input': {
                  color: '#fff',
                  '&::placeholder': {
                    color: 'rgba(255, 255, 255) !important',
                    padding: 0,
                  },
                },
              }}
            />
          )}
        />
        {error && <span style={{ color: 'red', fontSize: '.75rem' }}>{error}</span>}
      </Stack>

      <ApplyButton onClick={() => onApplyDate()}>{translate('apply')}</ApplyButton>
      {/* </ContentStyle> */}
    </MyDialog>
  );
}
